/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Customers_SDK_Models_StoreCustomerRewardsHistory = {
  storeCustomerId?: number;
  lineItemId?: number;
  orderId?: number;
  changeInPoints?: number;
  adjustmentSource?: Luci_Customers_SDK_Models_StoreCustomerRewardsHistory.adjustmentSource;
  reason?: string;
  title?: string;
  createdDate?: string;
};
export namespace Luci_Customers_SDK_Models_StoreCustomerRewardsHistory {
  export enum adjustmentSource {
    ACCRUAL = 'Accrual',
    REDEMPTION = 'Redemption',
    RETAILER = 'Retailer',
    DECREMENT = 'Decrement',
  }
}

